// extracted by mini-css-extract-plugin
export default {"summary":"ExploreColumnSummary-module__summary__Vc9LN"};